import React from 'react';
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  page: {
    padding: 10,
    fontSize: 8,
    fontFamily: 'Helvetica',
  },
  title: {
    fontSize: 12,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 6,
    textTransform: 'uppercase',
  },
  infoText: {
    textAlign: 'center',
    fontSize: 7,
    marginBottom: 1,
  },
  divider: {
    marginVertical: 6,
    borderBottomWidth: 0.5,
    borderBottomColor: '#000',
  },
  section: {
    marginBottom: 6,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  label: {
    width: '50%',
    textAlign: 'left',
  },
  value: {
    width: '50%',
    textAlign: 'right',
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 6,
  },
  totalLabel: {
    fontWeight: 'bold',
    fontSize: 9,
  },
  totalValue: {
    fontWeight: 'bold',
    fontSize: 9,
    textAlign: 'right',
  },
  thankYou: {
    marginTop: 10,
    textAlign: 'center',
    fontStyle: 'italic',
    fontSize: 7,
  },
});

const PaymentSlipDocument = ({ order = {}, payment = {} }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    try {
      return new Date(dateString).toLocaleString();
    } catch {
      return 'N/A';
    }
  };

  const formatCurrency = (value) =>
    parseFloat(value || 0).toFixed(2);

  return (
    <Document>
      <Page size="A7" style={styles.page}>
        <Text style={styles.title}>Payment Slip</Text>

        <Text style={styles.infoText}>Ceylonika Cosmetics (Pvt) Ltd</Text>
        <Text style={styles.infoText}>154/11, Pushparama Road, Kadawatha</Text>
        <Text style={styles.infoText}>info@ceylonikacosmetics.com</Text>
        <Text style={styles.infoText}>www.ceylonikacosmetics.com</Text>

        <View style={styles.divider} />

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Order No</Text>
            <Text style={styles.value}>{order.orderRef || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Consult ID</Text>
            <Text style={styles.value}>{order.consultantId || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>First Name</Text>
            <Text style={styles.value}>{order.firstName || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Second Name</Text>
            <Text style={styles.value}>{order.lastName || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Order Date/Time</Text>
            <Text style={styles.value}>{formatDate(order.orderDateTime)}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Paid Date/Time</Text>
            <Text style={styles.value}>{formatDate(new Date())}</Text>
          </View>
        </View>

        <View style={styles.divider} />

        <View style={styles.section}>
          <View style={styles.row}>
            <Text style={styles.label}>Payment Type</Text>
            <Text style={styles.value}>{payment.paymentType || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.label}>Payment Reference</Text>
            <Text style={styles.value}>{payment.paymentRef || '-'}</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.totalLabel}>Paid Amount</Text>
            <Text style={styles.totalValue}>Rs. {formatCurrency(payment.paidAmount)}</Text>
          </View>
        </View>

        <View style={styles.divider} />

        <View style={styles.totalRow}>
          <Text style={styles.label}>Order Total</Text>
          <Text style={styles.value}>Rs. {formatCurrency(order.orderCost)}</Text>
        </View>

        <Text style={styles.thankYou}>- Thank You -</Text>
      </Page>
    </Document>
  );
};

export default PaymentSlipDocument;
